import React, { useState, useEffect, useRef } from "react";
import APIUrls from "../../services/APIUrls";
import {
  postAxiosFormDataResponse,
  getAxiosResponse,
  deleteAxiosResponse,
  downloadFile,
} from "../../services/authApiRoutes/APImethods";
import { useParams } from "react-router-dom";
import {  useSelector } from "react-redux";

import { checkFileSizeInGb, formatBytes } from "../../services/Util";
import axios from "axios";
import Cookies from "universal-cookie";
import CustomProgressBar from "../global/CustomProgressBar";
import { confirmAlert } from "react-confirm-alert";
import { useTranslation } from 'react-i18next';
import $ from "jquery";
import Constants from "../../Constants";
import DateFormat from "../../pages/DateFormat";
const chunkSize = Constants.CHUNK_SIZE;
const cookies = new Cookies();

export default function ReferenceMaterialUpload() {
  const [files, setFiles] = useState([]);
  const [referenceMaterial, setReferenceMaterial] = useState([]);
  const [selectedfile, setSelectedFile] = useState("");
  const [currentFileIndex, setCurrentFileIndex] = useState(null);
  const [currentChunkIndex, setCurrentChunkIndex] = useState(null);
  const [documentVariant, setDocumentVariant] = useState();
  const fileQueue = useRef([]);
  const accountPermission = useSelector(
    (updateCustomerBootstrapData) => updateCustomerBootstrapData.customer_bootstrap_data,
  ).value;
  const [fileUploadPermission,setFileUploadPermission]=useState(false)
  
  const [chooseFocus, setChooseFocus] = useState(false);
  const params = useParams();
  const { t } = useTranslation();
  $(document).on("click",".delete-icon",function() {
      $(this).addClass('focusAdd');
   });
  const confirmReferenceMaterialDeletion = (referenceMaterial) => {
    setTimeout(() => {
      $("#react-confirm-alert").attr({
        'aria-modal': 'true',
        'role': 'dialog',
        'aria-labelledby':"deleteUploadfile"
        });
        $("h1").attr({
        'id': 'deleteUploadfile',
       });
      }, 200);
    setTimeout(() => {
      $('#accept-delete-source-material').trigger('focus');
      $(".react-confirm-alert-overlay").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          if($("button").hasClass("focusAdd")){
            $('.focusAdd').trigger('focus')
          }
        }
        });
    }, 500);
     
    confirmAlert({
      title: `${t('delete_reference_material_title')}`,
      message: (
        <p>{`${t('delete_reference_material_confirmation_message')}`} <br/><strong>{referenceMaterial.filename}</strong></p>
      ),
      buttons: [
        {
          label: `${t('button_accept')}`,
          id: 'accept-delete-source-material',
          onClick: () => deleteReferenceMaterial(referenceMaterial.id),
          onKeyDown : (e) => {
            if(e.key === Constants.TAB){
              if(e.shiftKey === true){
                e.preventDefault()
                $('#cancel-delete-source-material').trigger('focus');
              }
            }
          }
        },
        {
          label: `${t('button_cancel')}`,
          id: 'cancel-delete-source-material',
          onClick: () => {
            setTimeout(() => {
              $('.focusAdd').trigger('focus');
              $('.delete-icon').removeClass('focusAdd');
            }, 200);
            
          },
          onKeyDown : (e) => {
            if(e.key === Constants.TAB){
              if(e.shiftKey === false){
                e.preventDefault()
                $('#accept-delete-source-material').trigger('focus');
              }
            }
          }
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: false,
      overlayClassName: "delete_overlay",
    });
  };

  function deleteReferenceMaterial(referenceDocId) {
    deleteAxiosResponse(APIUrls.REFERENCE_FILE(params.id, referenceDocId)).then(
      (res) => {
        getAndPopulateReferenceMaterial();
        setTimeout(()=>{
         const uploadFocus = $('.uploading-file-list').length;
         if(uploadFocus=='1'){
          $('#reference-files').trigger('focus')
         }
        },1500)
     },
     
    );
  }

  function downloadAssetFile(referenceDocId) {
    let filename = [];
    filename = referenceMaterial.filter((reference) => {
      return reference.id === referenceDocId;
    });
    if (filename.length > 0) {
      downloadFile(
        APIUrls.DOWNLOAD_REFERENCE_FILE(params.id, referenceDocId),
        filename[0].filename
      );
    }
  }

  function readAndUploadCurrentChunk() {
    const reader = new FileReader();
    const file = files[currentFileIndex];
    if (!file) {
      return;
    }
    const from = currentChunkIndex * chunkSize;
    const to = from + chunkSize;
    const blob = file.slice(from, to);
    reader.onload = (e) => uploadChunk(e);
    reader.readAsDataURL(blob);
  }

  function uploadChunk(readerEvent) {

    const file = files[currentFileIndex];
    const data = readerEvent.target.result;
    const params = new URLSearchParams();
    params.set("name", file.name);
    params.set("size", file.size);
    params.set("docFileId", documentVariant);
    params.set("currentChunkIndex", currentChunkIndex);
    params.set("totalChunks", Math.ceil(file.size / chunkSize));
    $('.progressReport').trigger('focus');
    const headers = {
      "Content-Type": "application/octet-stream",
      "CSRF-Token": localStorage.getItem("csrfToken"),
    };
    const url =
      `${process.env.REACT_APP_BACKEND_SERVER}${APIUrls.REFERENCE_UPLOAD}?` +
      params.toString();
    axios.post(url, data, { headers }).then((response) => {
      const file = files[currentFileIndex];
      const filesize = files[currentFileIndex].size;
      const chunks = Math.ceil(filesize / chunkSize) - 1;
      const isLastChunk = currentChunkIndex === chunks;
      if (isLastChunk) {
        file.finalFilename = response.data.finalFilename;
        setCurrentChunkIndex(null);
        setFiles(files.filter((fileInfo) => fileInfo.name !== file.name));
        setCurrentFileIndex(null);
        getAndPopulateReferenceMaterial(true);
      } else {
        setCurrentChunkIndex(currentChunkIndex + 1);
      }
    });
  }
  const clearValue = (e) =>{
    e.target.value = null
  }
  function handleFileSelect(e) {
    if (files.length === 0) {
      postAxiosFormDataResponse(APIUrls.DOCUMENT_EDIT, {
        name: "REFERENCE_MATERIAL",
        "project.id": params.id,
        docType: "REFERENCE_MATERIAL",
      }).then((res) => {
        setDocumentVariant(res.data.documentFileId);
        setFiles((files) => [...files, selectedfile]);
        setCurrentFileIndex(0);
        setSelectedFile("");
      });
    } else {
      fileQueue.current.push(selectedfile);
      setSelectedFile("");
    }
  }

  function fileSelection(e) {
    if (e.target) {
      setSelectedFile(e.target.files[0]);
      const file=e.target.files[0];
      if(checkFileSizeInGb(file,accountPermission.maxFileUploadSizeGb)){
        setFileUploadPermission(true)
      }else{
        setFileUploadPermission(false)
      }
    }
  }

  function handleDrop(e) {
    e.preventDefault();
    if (e.dataTransfer) {
      setSelectedFile(e.dataTransfer.files[0]);
    }
  }

  function getAndPopulateReferenceMaterial(resumeFileUpload) {
      getAxiosResponse(APIUrls.REFERENCE_LIST(params.id)).then((res) => {
      setReferenceMaterial(res.data.data);
      if (resumeFileUpload && fileQueue.current.length > 0) {
        postAxiosFormDataResponse(APIUrls.DOCUMENT_EDIT_VARIANT, {
          name: "REFERENCE_MATERIAL",
          "project.id": params.id,
          docType: "REFERENCE_MATERIAL",
        }).then((res) => {
          setDocumentVariant(res.data.documentFileId);
          setFiles((files) => [...files, fileQueue.current.pop()]);
          setCurrentFileIndex(0);
          
        });
      }
      setTimeout(()=>{
        if (chooseFocus) {
          $('.uploading-file-list:last .download-icon').trigger('focus');
        } 
        else {
          setChooseFocus(true);
        }
      },500)
    });
    
  }

  useEffect(() => {
    getAndPopulateReferenceMaterial();
    return () => {
      setChooseFocus(false);
    };
  }, []);

  useEffect(() => {
    if (currentFileIndex !== null) {
      setCurrentChunkIndex(0);
    }
  }, [currentFileIndex]);

  useEffect(() => {
    if (currentChunkIndex !== null) {
      readAndUploadCurrentChunk();
    }
  }, [currentChunkIndex]);
  $(document).on("change","#reference-files",function() {
    $('#valid-upload').addClass('uploadBtnfocus')
    setTimeout(()=>{
      if($("button").hasClass("uploadBtnfocus")){
        $('#valid-upload').trigger('focus')
       }
    },1000)
  
  });
  
  return (
    <div className="tab-box col-md-9">
      <div
        className="upload-file-container flex"
        onDragOver={(e) => {
          e.preventDefault();
        }}
        onDragLeave={(e) => {
          e.preventDefault();
        }}
        onDrop={(e) => handleDrop(e)}
      >
        <div className="left-side">
          <div className="upload-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="50"
              height="50"
              viewBox="0 0 50 50"
              fill="none"
            >
              <path
                d="M31.125 34C31.125 34 38.398 34 39.0857 34C42.9051 34 46 30.8778 46 27.0255C46 23.1733 42.9051 20.0502 39.0857 20.0502C39.0682 20.0502 39.0525 20.0528 39.035 20.0528C39.0884 19.6168 39.1251 19.1754 39.1251 18.7252C39.1251 12.8021 34.366 8 28.4939 8C23.9185 8 20.0309 10.921 18.5311 15.0098C17.58 14.0485 16.264 13.4526 14.8115 13.4526C11.9074 13.4526 9.55363 15.8272 9.55363 18.7561C9.55363 18.8311 9.56238 18.9035 9.565 18.9777C6.35813 19.8719 4 22.8281 4 26.3476C4 30.5741 7.39588 34 11.5863 34C12.3099 34 18.875 34 18.875 34"
                stroke="#96ACCC"
                strokeWidth="2.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M21 28L25 23L29 28"
                stroke="#96ACCC"
                strokeWidth="2.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
              ></path>
              <path
                d="M25 41V24"
                stroke="#96ACCC"
                strokeWidth="2.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
              ></path>
            </svg>
          </div>
          <div className="upload-format">
            JPG, PNG, HTML or PDF <br />
            ( {accountPermission?.maxFileUploadSizeGb} GB or less)
          </div>
        </div>
        <div className="right-side">
          <div className="file-drag">Drag and drop your file or</div>
          <div className="input-file-container">
            <div className="input-file mar-bot20">
              <input
                type="file"
                id="reference-files"
                onChange={(e) => fileSelection(e)}
                onClick={(e) => clearValue(e)}
              />
              <label className="file-button" htmlFor="reference-files" createproject-tour="uploaded-reference">
                Choose file
              </label>
            </div>
            <div className="upload-file-ext flex-center">
              <div className="inline-flex">
              <strong className={selectedfile ? "show-flex" : "hide"}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="18"
                  viewBox="0 0 16 18"
                  fill="none"
                >
                  <path
                    d="M6.71373 3.85714V2.57143H5.42801V3.85714H6.71373ZM7.99944 5.14286V3.85714H6.71373V5.14286H7.99944ZM6.71373 6.42857V5.14286H5.42801V6.42857H6.71373ZM7.99944 7.71429V6.42857H6.71373V7.71429H7.99944ZM15.0307 3.81696C15.2182 4.00446 15.3789 4.25893 15.5128 4.58036C15.6468 4.90179 15.7137 5.19643 15.7137 5.46429V17.0357C15.7137 17.3036 15.62 17.5312 15.4325 17.7188C15.245 17.9062 15.0173 18 14.7494 18H1.24944C0.981585 18 0.753906 17.9062 0.566406 17.7188C0.378906 17.5312 0.285156 17.3036 0.285156 17.0357V0.964286C0.285156 0.696429 0.378906 0.46875 0.566406 0.28125C0.753906 0.09375 0.981585 0 1.24944 0H10.2494C10.5173 0 10.8119 0.0669643 11.1334 0.200893C11.4548 0.334821 11.7093 0.495536 11.8968 0.683036L15.0307 3.81696ZM10.5709 1.36607V5.14286H14.3477C14.2807 4.94866 14.207 4.81138 14.1267 4.73103L10.9827 1.58705C10.9023 1.5067 10.7651 1.43304 10.5709 1.36607ZM14.428 16.7143V6.42857H10.2494C9.98158 6.42857 9.75391 6.33482 9.56641 6.14732C9.37891 5.95982 9.28516 5.73214 9.28516 5.46429V1.28571H7.99944V2.57143H6.71373V1.28571H1.57087V16.7143H14.428ZM8.13002 9.4721L9.2048 12.9777C9.25837 13.1585 9.28516 13.3326 9.28516 13.5C9.28516 14.0558 9.04241 14.5162 8.55692 14.8811C8.07143 15.2461 7.45703 15.4286 6.71373 15.4286C5.97042 15.4286 5.35603 15.2461 4.87054 14.8811C4.38504 14.5162 4.1423 14.0558 4.1423 13.5C4.1423 13.3326 4.16908 13.1585 4.22266 12.9777C4.36328 12.5558 4.76507 11.2299 5.42801 9V7.71429H6.71373V9H7.50725C7.65458 9 7.78516 9.04353 7.899 9.13058C8.01283 9.21763 8.08984 9.33147 8.13002 9.4721ZM6.71373 14.1429C7.06864 14.1429 7.37165 14.0792 7.62277 13.952C7.87388 13.8248 7.99944 13.6741 7.99944 13.5C7.99944 13.3259 7.87388 13.1752 7.62277 13.048C7.37165 12.9208 7.06864 12.8571 6.71373 12.8571C6.35882 12.8571 6.0558 12.9208 5.80469 13.048C5.55357 13.1752 5.42801 13.3259 5.42801 13.5C5.42801 13.6741 5.55357 13.8248 5.80469 13.952C6.0558 14.0792 6.35882 14.1429 6.71373 14.1429Z"
                    fill="#157EFB"
                  ></path>
                </svg>
              </strong>
              <span>{selectedfile?.name} {!fileUploadPermission ?Constants.BLANK:formatBytes(selectedfile.size)}</span>
              </div>
            </div>
          </div>
          {!fileUploadPermission ? 
          <button
            className={selectedfile ? "btn" : "btn disabled"}
            id="valid-upload"
            disabled={selectedfile ? false : true}
            onClick={(e) => handleFileSelect(e)}
          >
            Upload
          </button>:<span className="textDanger">File size exceeds {accountPermission.maxFileUploadSizeGb} GB.</span>}
        </div>
      </div>
      <div className="gb-upload-files files">
        {files.map((file, fileIndex) => {
          let progress = 0;
          if (file.finalFilename) {
            progress = 100;
          } else {
            const uploading = fileIndex === currentFileIndex;
            const chunks = Math.ceil(file.size / chunkSize);
            if (uploading) {
              progress = Math.round((currentChunkIndex / chunks) * 100);
            } else {
              progress = 0;
            }
            if(chunks === 1){
               progress = 50;                                
            }
          }
          return (
            <div
              target="_blank"
              className={
                file.isUploadCompleted
                  ? "hide"
                  : "show-flex flex-center multiple-files"
              }
            >
              <div className="icon-block">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    d="M19.3612 24.1735H5.63886C4.72272 24.1723 3.84447 23.8078 3.19673 23.1599C2.54899 22.5121 2.18464 21.6338 2.18359 20.7176V4.28144C2.18481 3.36542 2.54924 2.48727 3.19696 1.83955C3.84469 1.19182 4.72284 0.827397 5.63886 0.826178H14.402C14.8572 0.825314 15.3081 0.914634 15.7286 1.08898C16.1491 1.26333 16.531 1.51925 16.852 1.84197L21.8 6.78539C22.4488 7.43731 22.8141 8.31894 22.8165 9.23868V20.7176C22.8154 21.6338 22.4511 22.5121 21.8034 23.1599C21.1556 23.8078 20.2774 24.1723 19.3612 24.1735ZM5.63886 2.47091C5.15889 2.47161 4.69878 2.66259 4.35939 3.00197C4.02 3.34136 3.82903 3.80147 3.82833 4.28144V20.7176C3.82903 21.1977 4.01998 21.6578 4.35935 21.9973C4.69872 22.3368 5.15883 22.5279 5.63886 22.5288H19.3612C19.8413 22.5279 20.3014 22.3368 20.6407 21.9973C20.9801 21.6578 21.1711 21.1977 21.1717 20.7176V9.2367C21.1706 8.75346 20.9786 8.29024 20.6375 7.94789L15.6895 3.00447C15.5208 2.83483 15.3202 2.70033 15.0992 2.60874C14.8782 2.51716 14.6412 2.47031 14.402 2.47091H5.63886Z"
                    fill="#EA6404"
                  ></path>
                  <path
                    d="M21.2624 9.02539H18.1999C17.2868 9.02452 16.4113 8.66138 15.7656 8.01568C15.1199 7.36998 14.7567 6.49447 14.7559 5.58131V1.65039H16.4006V5.58131C16.4011 6.05837 16.5909 6.51573 16.9282 6.85306C17.2655 7.19039 17.7229 7.38013 18.1999 7.38065H21.2624V9.02539Z"
                    fill="#EA6404"
                  ></path>
                  <path
                    d="M9.09858 16.2195C9.0335 16.2177 8.96983 16.2001 8.91305 16.1682C8.84727 16.134 8.77753 16.0958 8.70319 16.0537L6.1374 14.5458C6.07628 14.5057 6.02717 14.4498 5.99529 14.384C5.96422 14.3214 5.94779 14.2525 5.94727 14.1827C5.94722 14.1102 5.96364 14.0387 5.99529 13.9735C6.02596 13.9088 6.07551 13.8549 6.1374 13.8189L8.70319 12.3432C8.76483 12.3046 8.82978 12.2716 8.89727 12.2445C8.95114 12.2222 9.0087 12.2101 9.067 12.209C9.12446 12.2118 9.18064 12.2269 9.23173 12.2534C9.28281 12.2798 9.32761 12.317 9.36305 12.3623C9.44775 12.4479 9.49708 12.5623 9.50121 12.6827C9.50051 12.737 9.48529 12.7902 9.45713 12.8366C9.42521 12.891 9.37991 12.9363 9.32555 12.9682L6.58608 14.5557L6.53082 13.7662L9.31766 15.4327C9.37448 15.4644 9.42036 15.5125 9.44924 15.5708C9.475 15.6235 9.48849 15.6813 9.48871 15.7399C9.48922 15.8646 9.44217 15.9849 9.35713 16.0761C9.32648 16.1168 9.28762 16.1505 9.24308 16.1752C9.19855 16.2 9.14932 16.215 9.09858 16.2195Z"
                    fill="#EA6404"
                  ></path>
                  <path
                    d="M9.09903 16.3842C9.00676 16.3829 8.91629 16.3585 8.83588 16.3132C8.77009 16.2796 8.69772 16.2401 8.6214 16.1967L6.05232 14.6882C5.96296 14.631 5.89121 14.5502 5.84509 14.4546C5.80286 14.3702 5.78036 14.2773 5.7793 14.1829C5.78005 14.0858 5.80253 13.99 5.84509 13.9026C5.88955 13.8086 5.96161 13.7304 6.05167 13.6783L8.61745 12.2007C8.68592 12.1578 8.75815 12.1212 8.83324 12.0915C8.94371 12.0425 9.06734 12.0318 9.18457 12.061C9.30181 12.0902 9.40598 12.1576 9.48061 12.2526C9.5932 12.368 9.65785 12.5218 9.66153 12.6829C9.6609 12.7661 9.6382 12.8476 9.59574 12.9191C9.55045 12.9955 9.48693 13.0594 9.41088 13.1053L7.55496 14.1836L9.40759 15.2888C9.4929 15.3369 9.5617 15.4096 9.60496 15.4974C9.64142 15.5722 9.66053 15.6543 9.66088 15.7375C9.66142 15.9022 9.60014 16.0612 9.48917 16.1829C9.44246 16.2426 9.38342 16.2914 9.31609 16.3262C9.24876 16.3609 9.17472 16.3807 9.09903 16.3842ZM6.69443 14.6823L8.78719 15.9119C8.85759 15.9526 8.92469 15.9888 8.98917 16.0224C9.03118 16.0446 9.07979 16.0509 9.12608 16.0401C9.17237 16.0294 9.21322 16.0023 9.24114 15.9638C9.29873 15.9027 9.33033 15.8215 9.3293 15.7375C9.32891 15.7033 9.32081 15.6695 9.30561 15.6388C9.28959 15.6106 9.26555 15.5877 9.23653 15.573L7.22995 14.3724L6.69443 14.6823ZM6.37535 13.873L6.22009 13.9619C6.18718 13.9813 6.16083 14.0102 6.14443 14.0448C6.12361 14.0878 6.11282 14.1351 6.11285 14.1829C6.11324 14.2286 6.12404 14.2736 6.14443 14.3145C6.16336 14.3542 6.19297 14.388 6.22996 14.4119L6.4214 14.5237L6.37535 13.873ZM6.71877 14.0665L6.7339 14.2796L6.90627 14.179L6.71877 14.0665ZM6.71153 13.6796L7.23259 13.9901L9.24509 12.8244C9.27393 12.8073 9.29811 12.7833 9.31548 12.7546C9.32897 12.7331 9.33647 12.7083 9.33719 12.6829C9.33269 12.6032 9.29813 12.5282 9.24048 12.473C9.15166 12.3737 9.08785 12.3737 9.06745 12.3737C9.02994 12.3751 8.99297 12.3831 8.95824 12.3974C8.90003 12.4214 8.84391 12.4502 8.79048 12.4836L6.71153 13.6796Z"
                    fill="#EA6404"
                  ></path>
                  <path
                    d="M10.9549 17.2788C10.8531 17.2738 10.7558 17.2349 10.6786 17.1682C10.634 17.1357 10.5978 17.0928 10.5732 17.0434C10.5486 16.9939 10.5362 16.9393 10.5372 16.884C10.5379 16.8181 10.5539 16.7533 10.5839 16.6946L13.7891 10.1321C13.8233 10.062 13.8753 10.0021 13.9398 9.95837C13.9974 9.91694 14.0662 9.894 14.1372 9.89258C14.2372 9.89676 14.3329 9.93454 14.4089 9.99982C14.4536 10.033 14.4896 10.0766 14.5137 10.1268C14.5377 10.177 14.5492 10.2323 14.547 10.288C14.5462 10.3539 14.5302 10.4187 14.5003 10.4774L11.3029 17.0399C11.2695 17.1091 11.2193 17.1688 11.1569 17.2136C11.0981 17.256 11.0274 17.2788 10.9549 17.2788Z"
                    fill="#EA6404"
                  ></path>
                  <path
                    d="M10.9533 17.4419C10.8154 17.4371 10.6829 17.3864 10.577 17.2978C10.5125 17.2496 10.4603 17.1869 10.4245 17.1148C10.3887 17.0427 10.3704 16.9632 10.3711 16.8826C10.3724 16.791 10.3949 16.7009 10.4369 16.6195L13.6422 10.0609C13.6887 9.96447 13.76 9.88207 13.8487 9.82212C13.9489 9.75601 14.0681 9.725 14.1878 9.73393C14.3074 9.74285 14.4207 9.79123 14.5099 9.87146C14.5743 9.92043 14.6261 9.98393 14.6612 10.0568C14.6963 10.1296 14.7137 10.2097 14.7119 10.2905C14.7106 10.3822 14.6881 10.4723 14.6461 10.5537L11.4468 17.1123C11.4023 17.2069 11.3344 17.2887 11.2494 17.3498C11.1626 17.4103 11.0592 17.4425 10.9533 17.4419ZM14.1356 10.0603C14.0975 10.0609 14.0604 10.0733 14.0297 10.0958C13.9889 10.1234 13.9562 10.1613 13.9349 10.2057L10.7303 16.7649C10.7112 16.8012 10.7008 16.8416 10.7001 16.8826C10.6991 16.9129 10.7058 16.9429 10.7195 16.9699C10.7332 16.9969 10.7534 17.0201 10.7784 17.0373C10.8948 17.1267 10.9862 17.132 11.0606 17.0794C11.1008 17.0507 11.133 17.0122 11.154 16.9675L14.3507 10.4083C14.3697 10.3719 14.3801 10.3316 14.381 10.2905C14.383 10.26 14.3774 10.2295 14.3645 10.2018C14.3516 10.1741 14.3319 10.1501 14.3073 10.132C14.2592 10.0903 14.199 10.0652 14.1356 10.0603Z"
                    fill="#EA6404"
                  ></path>
                  <path
                    d="M15.998 16.2202C15.9405 16.2175 15.8842 16.2023 15.8332 16.1756C15.7822 16.1489 15.7376 16.1113 15.7026 16.0656C15.6177 15.9806 15.5683 15.8665 15.5645 15.7465C15.5638 15.6908 15.5789 15.6361 15.6079 15.5886C15.6415 15.5368 15.6865 15.4934 15.7395 15.4616L18.4789 13.8748L18.5342 14.6642L15.748 12.9978C15.6911 12.9662 15.6452 12.918 15.6164 12.8596C15.5907 12.807 15.5772 12.7492 15.577 12.6906C15.5755 12.5659 15.6227 12.4455 15.7086 12.355C15.7398 12.3137 15.7793 12.2793 15.8247 12.2541C15.87 12.229 15.9201 12.2136 15.9717 12.209C16.0368 12.2107 16.1005 12.2283 16.1572 12.2603C16.2226 12.2945 16.2923 12.3327 16.3664 12.3748L18.9322 13.8827C18.9939 13.9184 19.0434 13.9718 19.0743 14.036C19.1055 14.1014 19.1217 14.173 19.1217 14.2455C19.1217 14.318 19.1055 14.3896 19.0743 14.455C19.0436 14.5195 18.9941 14.5732 18.9322 14.609L16.3664 16.0853C16.3007 16.1221 16.2349 16.1511 16.177 16.18C16.121 16.2065 16.0599 16.2202 15.998 16.2202Z"
                    fill="#EA6404"
                  ></path>
                  <path
                    d="M15.9985 16.3842C15.9178 16.3818 15.8386 16.3619 15.7663 16.3259C15.6941 16.2899 15.6305 16.2387 15.58 16.1757C15.468 16.0603 15.4039 15.9068 15.4004 15.7461C15.3993 15.6604 15.4221 15.5761 15.4662 15.5026C15.5124 15.43 15.5745 15.3688 15.6478 15.3237L17.5096 14.2447L15.6603 13.1395C15.5746 13.0919 15.5057 13.0191 15.4629 12.9309C15.4265 12.8561 15.4074 12.774 15.407 12.6908C15.4063 12.5245 15.47 12.3645 15.5846 12.2441C15.6572 12.1469 15.7631 12.08 15.8821 12.0563C16.001 12.0326 16.1245 12.0538 16.2287 12.1158C16.2945 12.1493 16.3669 12.1888 16.4432 12.2322L19.009 13.7408C19.099 13.7928 19.1712 13.8708 19.2162 13.9645C19.2588 14.0523 19.2812 14.1485 19.282 14.2461C19.2814 14.3432 19.2589 14.439 19.2162 14.5263C19.1714 14.6209 19.0986 14.6994 19.0077 14.7513L16.4471 16.2283C16.3715 16.2691 16.305 16.3026 16.2439 16.3303C16.167 16.3661 16.0832 16.3845 15.9985 16.3842ZM17.8333 14.4382L15.8208 15.6039C15.792 15.6218 15.7673 15.6455 15.7485 15.6737C15.7352 15.6955 15.7286 15.7206 15.7294 15.7461C15.7335 15.8254 15.7676 15.9001 15.8248 15.9553C15.9142 16.0553 15.9781 16.0553 15.9985 16.0553C16.0351 16.055 16.0713 16.0467 16.1044 16.0309C16.159 16.0059 16.2189 15.9763 16.2833 15.9408L18.355 14.7493L17.8333 14.4382ZM18.6445 13.9072L18.6906 14.5559L18.8458 14.4664C18.8794 14.4475 18.9061 14.4185 18.9221 14.3836C18.9427 14.3404 18.9534 14.2932 18.9534 14.2454C18.9534 14.1976 18.9427 14.1504 18.9221 14.1072C18.906 14.0726 18.8793 14.044 18.8458 14.0257L18.6445 13.9072ZM18.1596 14.2493L18.3471 14.3618L18.332 14.1487L18.1596 14.2493ZM15.9669 12.3737C15.9109 12.3875 15.8615 12.4205 15.8274 12.4671C15.7982 12.4965 15.7752 12.5314 15.7596 12.5698C15.744 12.6082 15.7362 12.6494 15.7366 12.6908C15.737 12.725 15.7451 12.7588 15.7603 12.7895C15.7753 12.8173 15.7982 12.8402 15.8261 12.8553L17.8333 14.0559L18.3682 13.7461L16.2761 12.5164C16.2057 12.4757 16.1379 12.4395 16.0741 12.4059C16.0413 12.387 16.0046 12.376 15.9669 12.3737Z"
                    fill="#EA6404"
                  ></path>
                </svg>
              </div>
              <div className="right-progressbar">
                <label className="name">{file.name}</label>
                <CustomProgressBar
                  completed={progress !== "" ? progress : 0}
                  labelSize="14px"
                  width="100%"
                  labelClassName="progressBarLabel"
                  borderRadius="30px"
                  labelAlignment="outside"
                  labelLineHeight="1px"
                  labelColor="rgba(0,0,0,0.87)"
                  height="6px"
                  className="campaign_progress"
                  bgColor="#06B878"
                  baseBgColor="#D1DEF0"
                  ariaValuetext={progress !== "" ? progress : 0}
                  aria-label=""
                  aria-valuenow={progress !== "" ? progress : 0}
                />
              </div>
            </div>
          );
        })}

        {fileQueue.current.map((file, fileIndex) => {
          return (
            <div className={"show-flex flex-center multiple-files"}>
              <div className="icon-block">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 25 25"
                  fill="none"
                >
                  <path
                    d="M19.3612 24.1735H5.63886C4.72272 24.1723 3.84447 23.8078 3.19673 23.1599C2.54899 22.5121 2.18464 21.6338 2.18359 20.7176V4.28144C2.18481 3.36542 2.54924 2.48727 3.19696 1.83955C3.84469 1.19182 4.72284 0.827397 5.63886 0.826178H14.402C14.8572 0.825314 15.3081 0.914634 15.7286 1.08898C16.1491 1.26333 16.531 1.51925 16.852 1.84197L21.8 6.78539C22.4488 7.43731 22.8141 8.31894 22.8165 9.23868V20.7176C22.8154 21.6338 22.4511 22.5121 21.8034 23.1599C21.1556 23.8078 20.2774 24.1723 19.3612 24.1735ZM5.63886 2.47091C5.15889 2.47161 4.69878 2.66259 4.35939 3.00197C4.02 3.34136 3.82903 3.80147 3.82833 4.28144V20.7176C3.82903 21.1977 4.01998 21.6578 4.35935 21.9973C4.69872 22.3368 5.15883 22.5279 5.63886 22.5288H19.3612C19.8413 22.5279 20.3014 22.3368 20.6407 21.9973C20.9801 21.6578 21.1711 21.1977 21.1717 20.7176V9.2367C21.1706 8.75346 20.9786 8.29024 20.6375 7.94789L15.6895 3.00447C15.5208 2.83483 15.3202 2.70033 15.0992 2.60874C14.8782 2.51716 14.6412 2.47031 14.402 2.47091H5.63886Z"
                    fill="#EA6404"
                  ></path>
                  <path
                    d="M21.2624 9.02539H18.1999C17.2868 9.02452 16.4113 8.66138 15.7656 8.01568C15.1199 7.36998 14.7567 6.49447 14.7559 5.58131V1.65039H16.4006V5.58131C16.4011 6.05837 16.5909 6.51573 16.9282 6.85306C17.2655 7.19039 17.7229 7.38013 18.1999 7.38065H21.2624V9.02539Z"
                    fill="#EA6404"
                  ></path>
                  <path
                    d="M9.09858 16.2195C9.0335 16.2177 8.96983 16.2001 8.91305 16.1682C8.84727 16.134 8.77753 16.0958 8.70319 16.0537L6.1374 14.5458C6.07628 14.5057 6.02717 14.4498 5.99529 14.384C5.96422 14.3214 5.94779 14.2525 5.94727 14.1827C5.94722 14.1102 5.96364 14.0387 5.99529 13.9735C6.02596 13.9088 6.07551 13.8549 6.1374 13.8189L8.70319 12.3432C8.76483 12.3046 8.82978 12.2716 8.89727 12.2445C8.95114 12.2222 9.0087 12.2101 9.067 12.209C9.12446 12.2118 9.18064 12.2269 9.23173 12.2534C9.28281 12.2798 9.32761 12.317 9.36305 12.3623C9.44775 12.4479 9.49708 12.5623 9.50121 12.6827C9.50051 12.737 9.48529 12.7902 9.45713 12.8366C9.42521 12.891 9.37991 12.9363 9.32555 12.9682L6.58608 14.5557L6.53082 13.7662L9.31766 15.4327C9.37448 15.4644 9.42036 15.5125 9.44924 15.5708C9.475 15.6235 9.48849 15.6813 9.48871 15.7399C9.48922 15.8646 9.44217 15.9849 9.35713 16.0761C9.32648 16.1168 9.28762 16.1505 9.24308 16.1752C9.19855 16.2 9.14932 16.215 9.09858 16.2195Z"
                    fill="#EA6404"
                  ></path>
                  <path
                    d="M9.09903 16.3842C9.00676 16.3829 8.91629 16.3585 8.83588 16.3132C8.77009 16.2796 8.69772 16.2401 8.6214 16.1967L6.05232 14.6882C5.96296 14.631 5.89121 14.5502 5.84509 14.4546C5.80286 14.3702 5.78036 14.2773 5.7793 14.1829C5.78005 14.0858 5.80253 13.99 5.84509 13.9026C5.88955 13.8086 5.96161 13.7304 6.05167 13.6783L8.61745 12.2007C8.68592 12.1578 8.75815 12.1212 8.83324 12.0915C8.94371 12.0425 9.06734 12.0318 9.18457 12.061C9.30181 12.0902 9.40598 12.1576 9.48061 12.2526C9.5932 12.368 9.65785 12.5218 9.66153 12.6829C9.6609 12.7661 9.6382 12.8476 9.59574 12.9191C9.55045 12.9955 9.48693 13.0594 9.41088 13.1053L7.55496 14.1836L9.40759 15.2888C9.4929 15.3369 9.5617 15.4096 9.60496 15.4974C9.64142 15.5722 9.66053 15.6543 9.66088 15.7375C9.66142 15.9022 9.60014 16.0612 9.48917 16.1829C9.44246 16.2426 9.38342 16.2914 9.31609 16.3262C9.24876 16.3609 9.17472 16.3807 9.09903 16.3842ZM6.69443 14.6823L8.78719 15.9119C8.85759 15.9526 8.92469 15.9888 8.98917 16.0224C9.03118 16.0446 9.07979 16.0509 9.12608 16.0401C9.17237 16.0294 9.21322 16.0023 9.24114 15.9638C9.29873 15.9027 9.33033 15.8215 9.3293 15.7375C9.32891 15.7033 9.32081 15.6695 9.30561 15.6388C9.28959 15.6106 9.26555 15.5877 9.23653 15.573L7.22995 14.3724L6.69443 14.6823ZM6.37535 13.873L6.22009 13.9619C6.18718 13.9813 6.16083 14.0102 6.14443 14.0448C6.12361 14.0878 6.11282 14.1351 6.11285 14.1829C6.11324 14.2286 6.12404 14.2736 6.14443 14.3145C6.16336 14.3542 6.19297 14.388 6.22996 14.4119L6.4214 14.5237L6.37535 13.873ZM6.71877 14.0665L6.7339 14.2796L6.90627 14.179L6.71877 14.0665ZM6.71153 13.6796L7.23259 13.9901L9.24509 12.8244C9.27393 12.8073 9.29811 12.7833 9.31548 12.7546C9.32897 12.7331 9.33647 12.7083 9.33719 12.6829C9.33269 12.6032 9.29813 12.5282 9.24048 12.473C9.15166 12.3737 9.08785 12.3737 9.06745 12.3737C9.02994 12.3751 8.99297 12.3831 8.95824 12.3974C8.90003 12.4214 8.84391 12.4502 8.79048 12.4836L6.71153 13.6796Z"
                    fill="#EA6404"
                  ></path>
                  <path
                    d="M10.9549 17.2788C10.8531 17.2738 10.7558 17.2349 10.6786 17.1682C10.634 17.1357 10.5978 17.0928 10.5732 17.0434C10.5486 16.9939 10.5362 16.9393 10.5372 16.884C10.5379 16.8181 10.5539 16.7533 10.5839 16.6946L13.7891 10.1321C13.8233 10.062 13.8753 10.0021 13.9398 9.95837C13.9974 9.91694 14.0662 9.894 14.1372 9.89258C14.2372 9.89676 14.3329 9.93454 14.4089 9.99982C14.4536 10.033 14.4896 10.0766 14.5137 10.1268C14.5377 10.177 14.5492 10.2323 14.547 10.288C14.5462 10.3539 14.5302 10.4187 14.5003 10.4774L11.3029 17.0399C11.2695 17.1091 11.2193 17.1688 11.1569 17.2136C11.0981 17.256 11.0274 17.2788 10.9549 17.2788Z"
                    fill="#EA6404"
                  ></path>
                  <path
                    d="M10.9533 17.4419C10.8154 17.4371 10.6829 17.3864 10.577 17.2978C10.5125 17.2496 10.4603 17.1869 10.4245 17.1148C10.3887 17.0427 10.3704 16.9632 10.3711 16.8826C10.3724 16.791 10.3949 16.7009 10.4369 16.6195L13.6422 10.0609C13.6887 9.96447 13.76 9.88207 13.8487 9.82212C13.9489 9.75601 14.0681 9.725 14.1878 9.73393C14.3074 9.74285 14.4207 9.79123 14.5099 9.87146C14.5743 9.92043 14.6261 9.98393 14.6612 10.0568C14.6963 10.1296 14.7137 10.2097 14.7119 10.2905C14.7106 10.3822 14.6881 10.4723 14.6461 10.5537L11.4468 17.1123C11.4023 17.2069 11.3344 17.2887 11.2494 17.3498C11.1626 17.4103 11.0592 17.4425 10.9533 17.4419ZM14.1356 10.0603C14.0975 10.0609 14.0604 10.0733 14.0297 10.0958C13.9889 10.1234 13.9562 10.1613 13.9349 10.2057L10.7303 16.7649C10.7112 16.8012 10.7008 16.8416 10.7001 16.8826C10.6991 16.9129 10.7058 16.9429 10.7195 16.9699C10.7332 16.9969 10.7534 17.0201 10.7784 17.0373C10.8948 17.1267 10.9862 17.132 11.0606 17.0794C11.1008 17.0507 11.133 17.0122 11.154 16.9675L14.3507 10.4083C14.3697 10.3719 14.3801 10.3316 14.381 10.2905C14.383 10.26 14.3774 10.2295 14.3645 10.2018C14.3516 10.1741 14.3319 10.1501 14.3073 10.132C14.2592 10.0903 14.199 10.0652 14.1356 10.0603Z"
                    fill="#EA6404"
                  ></path>
                  <path
                    d="M15.998 16.2202C15.9405 16.2175 15.8842 16.2023 15.8332 16.1756C15.7822 16.1489 15.7376 16.1113 15.7026 16.0656C15.6177 15.9806 15.5683 15.8665 15.5645 15.7465C15.5638 15.6908 15.5789 15.6361 15.6079 15.5886C15.6415 15.5368 15.6865 15.4934 15.7395 15.4616L18.4789 13.8748L18.5342 14.6642L15.748 12.9978C15.6911 12.9662 15.6452 12.918 15.6164 12.8596C15.5907 12.807 15.5772 12.7492 15.577 12.6906C15.5755 12.5659 15.6227 12.4455 15.7086 12.355C15.7398 12.3137 15.7793 12.2793 15.8247 12.2541C15.87 12.229 15.9201 12.2136 15.9717 12.209C16.0368 12.2107 16.1005 12.2283 16.1572 12.2603C16.2226 12.2945 16.2923 12.3327 16.3664 12.3748L18.9322 13.8827C18.9939 13.9184 19.0434 13.9718 19.0743 14.036C19.1055 14.1014 19.1217 14.173 19.1217 14.2455C19.1217 14.318 19.1055 14.3896 19.0743 14.455C19.0436 14.5195 18.9941 14.5732 18.9322 14.609L16.3664 16.0853C16.3007 16.1221 16.2349 16.1511 16.177 16.18C16.121 16.2065 16.0599 16.2202 15.998 16.2202Z"
                    fill="#EA6404"
                  ></path>
                  <path
                    d="M15.9985 16.3842C15.9178 16.3818 15.8386 16.3619 15.7663 16.3259C15.6941 16.2899 15.6305 16.2387 15.58 16.1757C15.468 16.0603 15.4039 15.9068 15.4004 15.7461C15.3993 15.6604 15.4221 15.5761 15.4662 15.5026C15.5124 15.43 15.5745 15.3688 15.6478 15.3237L17.5096 14.2447L15.6603 13.1395C15.5746 13.0919 15.5057 13.0191 15.4629 12.9309C15.4265 12.8561 15.4074 12.774 15.407 12.6908C15.4063 12.5245 15.47 12.3645 15.5846 12.2441C15.6572 12.1469 15.7631 12.08 15.8821 12.0563C16.001 12.0326 16.1245 12.0538 16.2287 12.1158C16.2945 12.1493 16.3669 12.1888 16.4432 12.2322L19.009 13.7408C19.099 13.7928 19.1712 13.8708 19.2162 13.9645C19.2588 14.0523 19.2812 14.1485 19.282 14.2461C19.2814 14.3432 19.2589 14.439 19.2162 14.5263C19.1714 14.6209 19.0986 14.6994 19.0077 14.7513L16.4471 16.2283C16.3715 16.2691 16.305 16.3026 16.2439 16.3303C16.167 16.3661 16.0832 16.3845 15.9985 16.3842ZM17.8333 14.4382L15.8208 15.6039C15.792 15.6218 15.7673 15.6455 15.7485 15.6737C15.7352 15.6955 15.7286 15.7206 15.7294 15.7461C15.7335 15.8254 15.7676 15.9001 15.8248 15.9553C15.9142 16.0553 15.9781 16.0553 15.9985 16.0553C16.0351 16.055 16.0713 16.0467 16.1044 16.0309C16.159 16.0059 16.2189 15.9763 16.2833 15.9408L18.355 14.7493L17.8333 14.4382ZM18.6445 13.9072L18.6906 14.5559L18.8458 14.4664C18.8794 14.4475 18.9061 14.4185 18.9221 14.3836C18.9427 14.3404 18.9534 14.2932 18.9534 14.2454C18.9534 14.1976 18.9427 14.1504 18.9221 14.1072C18.906 14.0726 18.8793 14.044 18.8458 14.0257L18.6445 13.9072ZM18.1596 14.2493L18.3471 14.3618L18.332 14.1487L18.1596 14.2493ZM15.9669 12.3737C15.9109 12.3875 15.8615 12.4205 15.8274 12.4671C15.7982 12.4965 15.7752 12.5314 15.7596 12.5698C15.744 12.6082 15.7362 12.6494 15.7366 12.6908C15.737 12.725 15.7451 12.7588 15.7603 12.7895C15.7753 12.8173 15.7982 12.8402 15.8261 12.8553L17.8333 14.0559L18.3682 13.7461L16.2761 12.5164C16.2057 12.4757 16.1379 12.4395 16.0741 12.4059C16.0413 12.387 16.0046 12.376 15.9669 12.3737Z"
                    fill="#EA6404"
                  ></path>
                </svg>
              </div>
              <div className="right-progressbar">
                <label>{file.name}</label>
                <CustomProgressBar
                  completed={0}
                  labelSize="14px"
                  width="100%"
                  labelClassName="progressBarLabel"
                  borderRadius="30px"
                  labelAlignment="outside"
                  labelColor="rgba(0,0,0,0.87)"
                  height="6px"
                  labelLineHeight="1px"
                  className="campaign_progress"
                  bgColor="#06B878"
                  baseBgColor="#D1DEF0"
                  ariaValuetext={0}
                  aria-label=""
                  aria-valuenow={0}
                />
              </div>
            </div>
          );
        })}
      </div>
      <div className="uploading-files-block">
        {/* <small>Sit Tight while we’re uploading your files…</small> */}
        {/* <div className="uploading-file-list">here showing file section</div> */}
      </div>
      <div className="uploading-files-block uploading-success">
        {/* <small>File Uploaded Successfully!</small> */}

        {referenceMaterial?.map((reference, index) => {
          return (
            <div className="uploading-file-list flex">
              <div className="left-file-desc flex-center">
                <div className="icon-block">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="33"
                    height="33"
                    viewBox="0 0 33 33"
                    fill="none"
                  >
                    <path
                      d="M12.375 17.875H20.625M12.375 23.375H16.5M5.5 5.5V27.5C5.5 28.2293 5.78973 28.9288 6.30546 29.4445C6.82118 29.9603 7.52065 30.25 8.25 30.25H24.75C25.4793 30.25 26.1788 29.9603 26.6945 29.4445C27.2103 28.9288 27.5 28.2293 27.5 27.5V11.4703C27.5 11.1039 27.4267 10.7412 27.2846 10.4036C27.1424 10.0659 26.9342 9.76008 26.6723 9.504L20.5673 3.53375C20.0535 3.0314 19.3635 2.75009 18.645 2.75H8.25C7.52065 2.75 6.82118 3.03973 6.30546 3.55546C5.78973 4.07118 5.5 4.77065 5.5 5.5V5.5Z"
                      stroke="#2C8D94"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                    <path
                      d="M19.25 2.75V8.25C19.25 8.97935 19.5397 9.67882 20.0555 10.1945C20.5712 10.7103 21.2707 11 22 11H27.5"
                      stroke="#2C8D94"
                      strokeWidth="2"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <div className="file-text">
                  <span className="ext-name">{reference.filename}</span>
                  <strong>
                    <span className="date-name">
                      <DateFormat date={reference.createdDate} />
                    </span>
                    <span className="file-size">
                      {reference.sizeInKilobytes / 1000} MB
                    </span>
                  </strong>
                </div>
              </div>
              <div className="file-actions flex-center">
                <button
                  title={"Download - " + reference.filename}
                  aria-label={"Download " + reference.filename}
                  className="download-icon"
                  onClick={() => downloadAssetFile(reference.id)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="18"
                    viewBox="0 0 16 18"
                    fill="none"
                  >
                    <path
                      d="M8.00087 17.6527L15.0742 10.5794C15.1834 10.4518 15.2405 10.2878 15.234 10.12C15.2275 9.9522 15.158 9.79304 15.0392 9.67431C14.9205 9.55558 14.7614 9.48602 14.5936 9.47954C14.4258 9.47306 14.2617 9.53013 14.1342 9.63935L8.66753 15.0993V1.33268C8.66753 1.15587 8.5973 0.986302 8.47227 0.861278C8.34725 0.736254 8.17768 0.666016 8.00087 0.666016C7.82406 0.666016 7.65449 0.736254 7.52946 0.861278C7.40444 0.986302 7.3342 1.15587 7.3342 1.33268V15.0993L1.8742 9.63935C1.81444 9.56956 1.74089 9.51288 1.65818 9.47287C1.57547 9.43285 1.48538 9.41036 1.39357 9.40682C1.30176 9.40327 1.2102 9.41874 1.12465 9.45226C1.0391 9.48577 0.961404 9.53661 0.896434 9.60158C0.831464 9.66655 0.780626 9.74425 0.747109 9.8298C0.713593 9.91535 0.698122 10.0069 0.701669 10.0987C0.705215 10.1905 0.727702 10.2806 0.767717 10.3633C0.807733 10.446 0.864413 10.5196 0.934201 10.5794L8.00087 17.6527Z"
                      fill="#6D7080"
                    ></path>
                  </svg>
                </button>
                <button
                  title={"Delete - " + reference.filename}
                  aria-label={"Delete " + reference.filename}
                  className="delete-icon"
                  onClick={() => confirmReferenceMaterialDeletion(reference)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                  >
                    <path
                      d="M8.20039 3.80078H11.8004C11.8004 3.32339 11.6107 2.86555 11.2732 2.52799C10.9356 2.19042 10.4778 2.00078 10.0004 2.00078C9.523 2.00078 9.06516 2.19042 8.7276 2.52799C8.39003 2.86555 8.20039 3.32339 8.20039 3.80078ZM7.00039 3.80078C7.00039 3.00513 7.31646 2.24207 7.87907 1.67946C8.44168 1.11685 9.20474 0.800781 10.0004 0.800781C10.796 0.800781 11.5591 1.11685 12.1217 1.67946C12.6843 2.24207 13.0004 3.00513 13.0004 3.80078H19.0004C19.1595 3.80078 19.3121 3.864 19.4247 3.97652C19.5372 4.08904 19.6004 4.24165 19.6004 4.40078C19.6004 4.55991 19.5372 4.71252 19.4247 4.82505C19.3121 4.93757 19.1595 5.00078 19.0004 5.00078H17.7356L16.3028 17.4136C16.2015 18.291 15.7812 19.1006 15.1218 19.6883C14.4625 20.2759 13.61 20.6007 12.7268 20.6008H7.27399C6.39074 20.6007 5.53833 20.2759 4.87895 19.6883C4.21958 19.1006 3.79927 18.291 3.69799 17.4136L2.26519 5.00078H1.00039C0.841261 5.00078 0.688648 4.93757 0.576127 4.82505C0.463605 4.71252 0.400391 4.55991 0.400391 4.40078C0.400391 4.24165 0.463605 4.08904 0.576127 3.97652C0.688648 3.864 0.841261 3.80078 1.00039 3.80078H7.00039ZM4.88959 17.2768C4.9573 17.8617 5.23765 18.4012 5.67729 18.7929C6.11694 19.1845 6.68521 19.4009 7.27399 19.4008H12.7268C13.3156 19.4009 13.8838 19.1845 14.3235 18.7929C14.7631 18.4012 15.0435 17.8617 15.1112 17.2768L16.5272 5.00078H3.47359L4.88959 17.2768ZM8.20039 8.00078C8.35952 8.00078 8.51213 8.06399 8.62466 8.17652C8.73718 8.28904 8.80039 8.44165 8.80039 8.60078V15.8008C8.80039 15.9599 8.73718 16.1125 8.62466 16.225C8.51213 16.3376 8.35952 16.4008 8.20039 16.4008C8.04126 16.4008 7.88865 16.3376 7.77613 16.225C7.6636 16.1125 7.60039 15.9599 7.60039 15.8008V8.60078C7.60039 8.44165 7.6636 8.28904 7.77613 8.17652C7.88865 8.06399 8.04126 8.00078 8.20039 8.00078ZM12.4004 8.60078C12.4004 8.44165 12.3372 8.28904 12.2247 8.17652C12.1121 8.06399 11.9595 8.00078 11.8004 8.00078C11.6413 8.00078 11.4886 8.06399 11.3761 8.17652C11.2636 8.28904 11.2004 8.44165 11.2004 8.60078V15.8008C11.2004 15.9599 11.2636 16.1125 11.3761 16.225C11.4886 16.3376 11.6413 16.4008 11.8004 16.4008C11.9595 16.4008 12.1121 16.3376 12.2247 16.225C12.3372 16.1125 12.4004 15.9599 12.4004 15.8008V8.60078Z"
                      fill="#6D7080"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
